import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IProductDetail } from './productCategories';

export interface ICartProduct {
  product: IProductDetail;
  total: number;
  appointmentStart?: Date;
  appointmentEnd?: Date;
  laboratoryLanguage?: string[];
  quantity: number;
  index?: number;
}

export interface ICartState {
  cart: ICartProduct[];
}

const initialState: ICartState = {
  cart: [],
};

export const handleQuantity = (id: string, operation: string, shoppingCart: any) => {
  return shoppingCart.map((el: any) => {
    if (el.product.product_id === id) {
      if (operation === 'increment') {
        let quantity = el.quantity + 1;
        return {
          ...el,
          quantity: quantity,
          // subtotal: (el.price / 100) * quantity
        };
      } else {
        if (el.quantity === 1) return el;
        let quantity = el.quantity - 1;
        return {
          ...el,
          quantity: quantity,
          // subtotal: (el.price / 100) * quantity
        };
      }
    }
    return el;
  });
};

const cartSlice = createSlice({
  name: 'carts',
  initialState,
  reducers: {
    addCart: (state, action) => {
      state.cart.push({
        product: action.payload.product,
        total: action.payload.total,
        appointmentStart: action.payload.appointmentStart,
        appointmentEnd: action.payload.appointmentEnd,
        laboratoryLanguage: action.payload.laboratoryLanguage,
        quantity: action.payload.quantity,
      });
    },
    deleteCartByIndex: (state, action) => {
      const index = action.payload.index;
      if (index !== -1 && index < state.cart.length) {
        state.cart.splice(index, 1);
      }
    },
    deleteCart: (state) => {
      state.cart = [];
    },
    handleQuantityCart: (state, action) => {
      const updatedCart = handleQuantity(
        action.payload.productId,
        action.payload.operation,
        state.cart
      );
      state.cart = updatedCart;
    },
    updateCart: (state, action) => {
      const { index, updatedData } = action.payload;
      if (index >= 0 && index < state.cart.length) {
        state.cart[index] = { ...state.cart[index], ...updatedData };
      }
    },
  },
});

export const { addCart, deleteCart, deleteCartByIndex, handleQuantityCart, updateCart } =
  cartSlice.actions;

export default cartSlice.reducer;
export const selectCart = (state: RootState) => state.cart.cart;
